import PropTypes from 'prop-types';
import React from 'react';

/**
 * @description This component controls the width if it's children
 * according to preset breakpoints from the theme
 * To be used on all presentational components but header, footer and tab bar
 *
 * Plain CSS media query (matching MUI's default `xl: 1536px` breakpoint the
 * original used) rather than antd's Grid.useBreakpoint() hook — that hook
 * calls window.matchMedia, which isn't available in the Jest/JSDOM test
 * environment and broke every test that mounts a component using Wrapper.
 */

interface IProps {
  children?: React.ReactNode;
  customStyle?: any;
}

const Wrapper: React.FC<IProps> = (props) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <div
        className="ast-wrapper-inner"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          ...props.customStyle,
        }}>
        {props.children}
      </div>
      <style>{`
        .ast-wrapper-inner { width: 90vw; }
        @media (min-width: 1536px) {
          .ast-wrapper-inner { width: 73vw; margin-left: auto; margin-right: auto; }
        }
        /*
         * The 90vw/73vw sizing above assumes Wrapper sits directly under the
         * full page (its documented use case). Nested inside an antd Modal
         * (e.g. the SR detail dialogs), the modal is already narrower than
         * the viewport, so a vw-based width here — relative to the whole
         * browser window, not this modal's own box — over/under-shoots the
         * modal's actual content area, misaligning or clipping it. Fill the
         * modal's own container instead whenever Wrapper is used inside one.
         */
        .ant-modal .ast-wrapper-inner {
          width: 100%;
          margin-left: 0;
          margin-right: 0;
        }
      `}</style>
    </div>
  );
};

Wrapper.propTypes = {children: PropTypes.node};

export default Wrapper;
